import { createFileRoute } from '@tanstack/react-router'
import { throwLegacyRedirect } from '../lib/legacy-redirect'

export const Route = createFileRoute('/car-detailing-geelong')({
  beforeLoad: ({ location }) => {
    throwLegacyRedirect(location.pathname, location.searchStr)
  },
  component: () => null,
  head: () => ({
    title: 'Professional Vehicle Detailing | Autoglow Detailing',
    meta: [{ name: 'robots', content: 'noindex,follow' }],
  }),
})
